import { Dispatch, SetStateAction, useState } from 'react';

export interface UseNavbar {
  setOpenMenu: Dispatch<SetStateAction<boolean>>;
  openMenu: boolean;
  setCloseMenuOnScroll: Dispatch<SetStateAction<boolean>>;
  closeMenuOnScroll: boolean;
}

export default function useNavbar(): UseNavbar {
  const [openMenu, setOpenMenu] = useState(false);
  const [closeMenuOnScroll, setCloseMenuOnScroll] = useState(true);

  return {
    openMenu,
    setOpenMenu,
    closeMenuOnScroll,
    setCloseMenuOnScroll,
  };
}
